import React, { Component } from 'react';
import { Button, Navbar, NavItem, Icon, Footer } from 'react-materialize';
import * as $ from 'jquery';
import ChartEditor from '../components/chart-editor/ChartEditor';
import ResizeDetector from 'react-resize-detector';
import _ from 'lodash';
const cf = window.cf;

export default class SimpleChart extends Component {

    constructor(props){
        super(props);
        this.state = {
            chartEditorIsOpen:false,
            chartId:'',
            title:'',
            subtitle:'',
            chartHeight: 350,
            grid: cf.Grid().top(10).bottom(35).left(50).right(15),
            chartWidth: 300,
        };
        this.onResize = this.onResize.bind(this);
    }

    onResize(v1,v2) {
        this.state.chartHeight = v2 - 130;
        this.state.chartWidth = v1 - 50;
        this.forceUpdate();
    }

    componentDidMount(){
        let self = this;
        var providers = [{
            name:'Elasticsearch',
            provider:'elasticsearch',
            url:'https://chartfactor.com/elastic/',
            metadata: {
                'ticket_sales': {
                    'fields': {
                        'pricepaid': { 'label': 'Price Paid', 'type': 'MONEY' },
                        'commission': { 'type': 'MONEY' }
                    }
                }
            }
        }]
        let grid = _.cloneDeep(this.state.grid)
        cf.setProviders(providers);

        let metrics = [];
        var ticketSales = cf.provider('Elasticsearch').source('ticket_sales');
        var metric = cf.Metric('commission','sum');
        let countMetric = cf.Metric("count");
        metrics.push(metric);
        metrics.push(countMetric);
        var group = cf.Attribute('venuecity.keyword').limit(10).sort('desc',metric);
        var myData = ticketSales.groupby(group).metrics(...metrics);
        var myChart = myData.graph('Bars')
                            .set('axisLabels', true)
                            .set('grid',  grid)
                            .set('legend',cf.Legend())
                            .set('xAxis', { show: true })
                            .set('yAxis', { show: true })
                            .element('chart');
        myChart.execute();
        this.setState({chartId:'chart'});

        //setTimeout(function() { self.openChartEditor(); }, 500);
    }

    openChartEditor(){
        $(".editModeHelpText").hide();
        this.setState({chartEditorIsOpen:true});
    }
    closeChartEditor(){
        this.setState({chartEditorIsOpen:false});
    }
    onSave(value){
        this.setState(value)
    }
    render(){
        return (
            <div style={{width:'100%',height: '100%' }}>
                <div style={{width:'100%',height: '100%' }} className="demo-ct">
                    <Button style={{margin:'6px 0px'}} onClick={this.openChartEditor.bind(this)}>Edit</Button>
                    <spam className="editModeHelpText"> &larr; Use this button to open the edit mode </spam>
                    {this.state.title != '' &&
                        <div className="ce-chart-title">{this.state.title}</div>
                    }
                    {this.state.title == '' &&
                        <div className="ce-chart-title" style={{color:"gray"}}>Enter a title</div>
                    }
                    {this.state.subtitle != '' &&
                        <div className="ce-chart-subtitle" >{this.state.subtitle}</div>
                    }
                    {this.state.subtitle == '' &&
                        <div className="ce-chart-subtitle" style={{color:"gray"}}>Enter a subtitle</div>
                    }
                    <div id="chart" style={{height:this.state.chartHeight+'px', width:this.state.chartWidth+'px'}}></div>
                    <ChartEditor
                        chartId={this.state.chartId}
                        isOpen={this.state.chartEditorIsOpen}
                        title={this.state.title}
                        subtitle={this.state.subtitle}
                        grid={this.state.grid}
                        close={this.closeChartEditor.bind(this)}
                        onSave={this.onSave.bind(this)}/>
                    <ResizeDetector handleWidth handleHeight onResize={this.onResize} />
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/simple-chart/SimpleChart.jsx